/**
 * Create the store with asynchronously loaded reducers
 */
import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "./reducer";


export const store = configureStore({ reducer });
